<section id="Home" class="banner-section">
    <ngx-slick-carousel #slickModal="slick-carousel" [config]="settings" class="banner-slider" id="bannerSlider">
        <div ngxSlickItem class="single-banner img-responsive" [style.background-image]="'url('+item.img+')'"
            *ngFor="let item of banner; let i = index" [attr.data-index]="i">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-7">
                        <div class="banner-content pl-5">
                            <h1 data-animation="fadeInUp" data-delay="1s" [innerHtml]="item.title"></h1>
                            <p class="subtitleBanner" data-animation="fadeInUp" data-delay="1s" [innerHtml]="item.subtitle"></p>
                            <ul class="btn-wrap">
                                <li data-animation="fadeInLeft" data-delay="1.2s">
                                    <a *ngIf="i!=0" routerLink="{{item.link}}" class="main-btn main-btn-4">{{item.btnText}}</a>
                                    <button *ngIf="i==0" style="font-size: 17px"(click)="goToEstandar()" class="main-btn main-btn-4">{{item.btnText}}</button>
                                    <button *ngIf="i==0" (click)="goToValidar()" class="main-btn main-btn-4 ml-2 mt-2">Validar carne</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ngx-slick-carousel>
    <div class="testimonial-quote-icon" style="height: 100px;">
    </div>
</section>